import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { SkeletonRoundProps } from '../types';

const SkeletonRound = ({ size = 48, maxSize, dataTestId }: SkeletonRoundProps) => (
  <Container
    height={size}
    width={size}
    maxHeight={maxSize}
    maxWidth={maxSize}
    backgroundColor="grey_300"
    borderRadius="circle"
    data-testid={dataTestId}
  />
);

SkeletonRound.displayName = 'SkeletonRound';

export default SkeletonRound;
